import classNames from 'classnames';
import React, {useEffect, useState} from 'react';

import {isSimpleClick} from 'BenchlingUtil';
import {TableDimension} from 'notebook/tables/TableConstants';
import getTestProps from 'test/lib/cypress/getTestProps';

/**
 * Renders a six-dot ⠿ dragger handle for dragging a table row or column.
 *
 * @param props.dim - The dimension of the axis cell. If COLUMN, the dragger is horizontal. If ROW, the dragger is vertical.
 * @param props.onMouseDown - Callback called when the dragger receives a mousedown event. If the callback returns true, the dragger will enter a dragging visual state.
 * @returns Drag handle component
 */
export default function TableAxisCellDragHandle(props: {
  dim: TableDimension;
  onMouseDown: () => boolean;
}): JSX.Element {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    function onMouseUp(e: MouseEvent): void {
      if (isSimpleClick(e)) {
        setIsDragging(false);
      }
    }
    window.addEventListener('mouseup', onMouseUp);
    return () => {
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, []);
  return (
    <div
      className={classNames('axisCell-dragHandle-container', {
        'axisCell-dragHandle-container--column': props.dim === TableDimension.COLUMN,
        'axisCell-dragHandle-container--row': props.dim === TableDimension.ROW,
      })}
      {...getTestProps({component: 'TableAxisCellDragHandle', element: 'root'})}
    >
      <div
        className={classNames('axisCell-dragHandle', {
          'axisCell-dragHandle--is-dragging': isDragging,
        })}
        {...getTestProps({component: 'TableAxisCellDragHandle', element: 'handle'})}
        onMouseDown={(e) => {
          if (isSimpleClick(e)) {
            e.stopPropagation();
            const startedDrag = props.onMouseDown();
            if (startedDrag) {
              setIsDragging(true);
            }
          }
        }}
      />
    </div>
  );
}
